.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: map.get($radius, 'md');
  border: 1px solid;

  @include transition(background-color, border-color, box-shadow);
}

// Not Contacted state - grey background
.notContacted {
  background-color: var(--color-grey-light);
  border-color: var(--color-grey-light);

  &:hover {
    box-shadow: 0px 1px 4px 0px var(--color-grey-soft);
  }
}

// Contacted state - white background with border
.contacted {
  background-color: var(--color-surface-primary);
  border-color: var(--color-grey-soft);

  &:hover {
    box-shadow: 0px 1px 4px 0px var(--color-grey-soft);
  }
}

.contactInfo {
  display: flex;
  align-items: flex-start;
  gap: map.get($spacing-scale, 's-3');
  padding: map.get($spacing-scale, 's-3');
}

.icon {
  flex-shrink: 0;
}

.editButton {
  flex-shrink: 0;
  opacity: 0;

  .container:hover & {
    opacity: 1;
  }

  @include transition(opacity);
}

.content {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 's-1');
  min-width: 0;
  flex: 1;
}

.name {
  @include body-medium;
  color: var(--color-text-primary);
  margin: 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subtitle {
  @include body-small-regular;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: map.get($spacing-scale, 's-3') map.get($spacing-scale, 's-4');
  border-top: 1px solid var(--color-grey-soft);
}

.actionButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: map.get($spacing-scale, 's-2');
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-text-primary);

  @include transition(opacity);

  &:hover {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: 2px;
    border-radius: map.get($radius, 'sm');
  }
}

.actionText {
  @include body-small-medium;
  color: var(--color-text-primary);
}
